var map = {
	"./admin/back-light-yellow.svg": "./src/assets/img/admin/back-light-yellow.svg",
	"./admin/chevron-down-white.svg": "./src/assets/img/admin/chevron-down-white.svg",
	"./admin/disable-green.svg": "./src/assets/img/admin/disable-green.svg",
	"./admin/disable-white.svg": "./src/assets/img/admin/disable-white.svg",
	"./admin/edit-green.svg": "./src/assets/img/admin/edit-green.svg",
	"./admin/edit-white.svg": "./src/assets/img/admin/edit-white.svg",
	"./admin/email-green.svg": "./src/assets/img/admin/email-green.svg",
	"./admin/email-white.svg": "./src/assets/img/admin/email-white.svg",
	"./admin/eye-white.svg": "./src/assets/img/admin/eye-white.svg",
	"./admin/link-green.svg": "./src/assets/img/admin/link-green.svg",
	"./admin/link-white.svg": "./src/assets/img/admin/link-white.svg",
	"./admin/plus-green.svg": "./src/assets/img/admin/plus-green.svg",
	"./admin/plus-white.svg": "./src/assets/img/admin/plus-white.svg",
	"./admin/send-green.svg": "./src/assets/img/admin/send-green.svg",
	"./admin/send-white.svg": "./src/assets/img/admin/send-white.svg",
	"./admin/trash-green.svg": "./src/assets/img/admin/trash-green.svg",
	"./admin/trash-white.svg": "./src/assets/img/admin/trash-white.svg",
	"./admin/unlink-green.svg": "./src/assets/img/admin/unlink-green.svg",
	"./admin/unlink-white.svg": "./src/assets/img/admin/unlink-white.svg",
	"./admin/x-white.svg": "./src/assets/img/admin/x-white.svg",
	"./arrow-down-black.svg": "./src/assets/img/arrow-down-black.svg",
	"./arrow-down.svg": "./src/assets/img/arrow-down.svg",
	"./arrow-right.svg": "./src/assets/img/arrow-right.svg",
	"./avatar-maud.svg": "./src/assets/img/avatar-maud.svg",
	"./avatar.svg": "./src/assets/img/avatar.svg",
	"./back.svg": "./src/assets/img/back.svg",
	"./blue-arrow-left.svg": "./src/assets/img/blue-arrow-left.svg",
	"./blue-arrow-right.svg": "./src/assets/img/blue-arrow-right.svg",
	"./blue-pagination-arrow.svg": "./src/assets/img/blue-pagination-arrow.svg",
	"./blue-pagination-button.svg": "./src/assets/img/blue-pagination-button.svg",
	"./bubble-bottom.svg": "./src/assets/img/bubble-bottom.svg",
	"./calendar.svg": "./src/assets/img/calendar.svg",
	"./calendar/add.svg": "./src/assets/img/calendar/add.svg",
	"./calendar/default-seed-card.jpg": "./src/assets/img/calendar/default-seed-card.jpg",
	"./calendar/event-empty.svg": "./src/assets/img/calendar/event-empty.svg",
	"./calendar/herb1.svg": "./src/assets/img/calendar/herb1.svg",
	"./calendar/herb2.svg": "./src/assets/img/calendar/herb2.svg",
	"./calendar/info.svg": "./src/assets/img/calendar/info.svg",
	"./calendar/main-bg.svg": "./src/assets/img/calendar/main-bg.svg",
	"./calendar/spirale.svg": "./src/assets/img/calendar/spirale.svg",
	"./chatbot-infos/en/1.png": "./src/assets/img/chatbot-infos/en/1.png",
	"./chatbot-infos/en/2.png": "./src/assets/img/chatbot-infos/en/2.png",
	"./chatbot-infos/en/3.png": "./src/assets/img/chatbot-infos/en/3.png",
	"./chatbot-infos/fr/1.png": "./src/assets/img/chatbot-infos/fr/1.png",
	"./chatbot-infos/fr/2.png": "./src/assets/img/chatbot-infos/fr/2.png",
	"./chatbot-infos/fr/3.png": "./src/assets/img/chatbot-infos/fr/3.png",
	"./chatbot-loader.svg": "./src/assets/img/chatbot-loader.svg",
	"./chatbot.svg": "./src/assets/img/chatbot.svg",
	"./check-dark-green.svg": "./src/assets/img/check-dark-green.svg",
	"./check-green.svg": "./src/assets/img/check-green.svg",
	"./check-white.svg": "./src/assets/img/check-white.svg",
	"./check.svg": "./src/assets/img/check.svg",
	"./chevron-right.svg": "./src/assets/img/chevron-right.svg",
	"./close.svg": "./src/assets/img/close.svg",
	"./dashboard.svg": "./src/assets/img/dashboard.svg",
	"./doodle-arrow-left.svg": "./src/assets/img/doodle-arrow-left.svg",
	"./doodle-arrow-right.svg": "./src/assets/img/doodle-arrow-right.svg",
	"./doodle-file.svg": "./src/assets/img/doodle-file.svg",
	"./doodle-folder-green.svg": "./src/assets/img/doodle-folder-green.svg",
	"./edit.svg": "./src/assets/img/edit.svg",
	"./form-maintenance/talk.svg": "./src/assets/img/form-maintenance/talk.svg",
	"./game-content-trivia/answer-success.svg": "./src/assets/img/game-content-trivia/answer-success.svg",
	"./game-content-trivia/answer-wrong.svg": "./src/assets/img/game-content-trivia/answer-wrong.svg",
	"./half-turn.svg": "./src/assets/img/half-turn.svg",
	"./help-circle.svg": "./src/assets/img/help-circle.svg",
	"./home-comment-1.svg": "./src/assets/img/home-comment-1.svg",
	"./home-comment-2.svg": "./src/assets/img/home-comment-2.svg",
	"./home.svg": "./src/assets/img/home.svg",
	"./home/bg-pattern.svg": "./src/assets/img/home/bg-pattern.svg",
	"./home/column.svg": "./src/assets/img/home/column.svg",
	"./home/leaves.png": "./src/assets/img/home/leaves.png",
	"./home/room-activities.png": "./src/assets/img/home/room-activities.png",
	"./home/room-garden.png": "./src/assets/img/home/room-garden.png",
	"./home/room-library.png": "./src/assets/img/home/room-library.png",
	"./home/room-service.png": "./src/assets/img/home/room-service.png",
	"./home/title-activities.svg": "./src/assets/img/home/title-activities.svg",
	"./home/title-garden.svg": "./src/assets/img/home/title-garden.svg",
	"./home/title-library.svg": "./src/assets/img/home/title-library.svg",
	"./home/title-service.svg": "./src/assets/img/home/title-service.svg",
	"./john.gif": "./src/assets/img/john.gif",
	"./login.svg": "./src/assets/img/login.svg",
	"./login/plant-green.svg": "./src/assets/img/login/plant-green.svg",
	"./login/plant-light-green.svg": "./src/assets/img/login/plant-light-green.svg",
	"./login/plant-orange.svg": "./src/assets/img/login/plant-orange.svg",
	"./logo-green.png": "./src/assets/img/logo-green.png",
	"./logo.png": "./src/assets/img/logo.png",
	"./logout.svg": "./src/assets/img/logout.svg",
	"./maude.gif": "./src/assets/img/maude.gif",
	"./modal-concours-miniature.jpg": "./src/assets/img/modal-concours-miniature.jpg",
	"./notepad/link.svg": "./src/assets/img/notepad/link.svg",
	"./notepad/loupe.svg": "./src/assets/img/notepad/loupe.svg",
	"./notepad/main-bg.svg": "./src/assets/img/notepad/main-bg.svg",
	"./notepad/no-access.png": "./src/assets/img/notepad/no-access.png",
	"./notepad/notepad-bg.svg": "./src/assets/img/notepad/notepad-bg.svg",
	"./notepad/notepad-clip.svg": "./src/assets/img/notepad/notepad-clip.svg",
	"./notepad/notepad-pin.svg": "./src/assets/img/notepad/notepad-pin.svg",
	"./notepad/search.svg": "./src/assets/img/notepad/search.svg",
	"./notepad/stamp-1.svg": "./src/assets/img/notepad/stamp-1.svg",
	"./notepad/stamp-2.svg": "./src/assets/img/notepad/stamp-2.svg",
	"./padlock.svg": "./src/assets/img/padlock.svg",
	"./plus-white.svg": "./src/assets/img/plus-white.svg",
	"./plus.svg": "./src/assets/img/plus.svg",
	"./potagers/s02.jpg": "./src/assets/img/potagers/s02.jpg",
	"./potagers/s03.jpg": "./src/assets/img/potagers/s03.jpg",
	"./potagers/s032.jpg": "./src/assets/img/potagers/s032.jpg",
	"./profile.svg": "./src/assets/img/profile.svg",
	"./send.svg": "./src/assets/img/send.svg",
	"./settings.svg": "./src/assets/img/settings.svg",
	"./stamp-en.svg": "./src/assets/img/stamp-en.svg",
	"./stamp-fr.svg": "./src/assets/img/stamp-fr.svg",
	"./star.svg": "./src/assets/img/star.svg",
	"./stats.svg": "./src/assets/img/stats.svg",
	"./students.svg": "./src/assets/img/students.svg",
	"./tab-icon-archives.svg": "./src/assets/img/tab-icon-archives.svg",
	"./tab-icon-maintenance.svg": "./src/assets/img/tab-icon-maintenance.svg",
	"./thumb-down-empty.svg": "./src/assets/img/thumb-down-empty.svg",
	"./thumb-down-full.svg": "./src/assets/img/thumb-down-full.svg",
	"./thumb-up-empty.svg": "./src/assets/img/thumb-up-empty.svg",
	"./thumb-up-full.svg": "./src/assets/img/thumb-up-full.svg",
	"./trash.svg": "./src/assets/img/trash.svg",
	"./user-check.svg": "./src/assets/img/user-check.svg",
	"./user-menu/checked.svg": "./src/assets/img/user-menu/checked.svg",
	"./user-menu/external-link.svg": "./src/assets/img/user-menu/external-link.svg",
	"./user-x.svg": "./src/assets/img/user-x.svg",
	"./users.svg": "./src/assets/img/users.svg",
	"./white-arrow-left.svg": "./src/assets/img/white-arrow-left.svg",
	"./white-arrow-right.svg": "./src/assets/img/white-arrow-right.svg",
	"./yellow-arrow-left.svg": "./src/assets/img/yellow-arrow-left.svg",
	"./yellow-arrow-right.svg": "./src/assets/img/yellow-arrow-right.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*$";